export const convertErrorToStringMessages = (e: any): string[] => {
  if (e instanceof Error) {
    return [e.message];
  }
  if (e instanceof Array) {
    return e.map((err) => convertErrorToStringMessages(err)).flat();
  }

  // if there was a message there return it, otherwise stringify.
  const message: string = 'message' in e ? e.message : JSON.stringify(e);
  return [message];
};
